import React from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { SupportCategoryItem } from '@/api/placementApi.schemas';
import Donut from '@/components/donut/donut';
import { DEFAULT_CATEGORY_COLOR } from '@/constants/categoryColors';

import styles from './styles.module.css';

interface WalletCardArbitrageProps {
  title: string;
  categories: SupportCategoryItem[];
}

// Les catégories arrivent prêtes à l'affichage : l'API renvoie déjà le libellé canonique, le
// pourcentage, le montant et la couleur (cf. SupportCategoryResolver côté back). On les consomme
// dans l'ordre du tableau, sans retraitement.
export const WalletCardArbitrage: React.FC<WalletCardArbitrageProps> = ({ title, categories }) => {
  const { t } = useTranslation();

  return (
    <MtxGrid col={12} colXs={11} colSm={6} colMd={6} colLg={6} colXl={6}>
      <div className={styles.summaryWalletCard}>
        <div className={styles.before}>
          <span>{title}</span>
        </div>
        <div className={styles.donutContainer}>
          <Donut
            label={categories.map((category) => category.name ?? '')}
            dataData={categories.map((category) => category.pourcentTotal)}
            background={categories.map((category) => category.couleur ?? DEFAULT_CATEGORY_COLOR)}
            amounts={categories.map((category) => category.montantTotal)}
          />
        </div>
        {categories.map((category) => (
          <div key={category.name ?? ''} className={styles.summaryWalletDetails}>
            <div className={styles.detailSupportName}>
              <div
                className={styles.colorCircle}
                style={{ backgroundColor: category.couleur ?? DEFAULT_CATEGORY_COLOR }}
              />
              <p className={styles.supportName}>{category.name}</p>
            </div>
            <div className={styles.detailsSupportPercentage}>
              <span>{t('format.percentFlexible', { value: category.pourcentTotal })}</span>
            </div>
          </div>
        ))}
      </div>
    </MtxGrid>
  );
};
